import ButtonProps from './type';
import Loader from '../Loader';
import { ButtonStyled, ButtonChildrenStyled } from './styled';

const Button = ({ children, onClick, ...props }: ButtonProps) => {
  const { disabled, loading, startAdornment, endAdornment, variant, contentStyle, ...rest } = props;
  const loaderColor = variant === 'inverted' ? '#FFF' : null;
  const loaderComponent = <Loader size={16} color={loaderColor} />;

  return (
    <ButtonStyled {...rest} variant={variant} disabled={disabled || loading} onClick={onClick}>
      <ButtonChildrenStyled style={contentStyle} endAdornment={endAdornment}>
        {startAdornment && loading ? loaderComponent : startAdornment}
        {!startAdornment && loading ? loaderComponent : children}
      </ButtonChildrenStyled>
      {!loading && endAdornment}
    </ButtonStyled>
  );
};

Button.defaultProps = {
  loading: false,
  disabled: false,
};
export default Button;
